import type { ColumnDef } from "@tanstack/react-table";
import type { Placement } from "@/types";
import { Badge } from "@trillion/ui/components/ui/badge";
import { createActionsColumn } from "@trillion/ui";

interface PlacementColumnsOptions {
  onEdit: (placement: Placement) => void;
  onDelete: (placement: Placement) => void;
}

export function getPlacementColumns({
  onEdit,
  onDelete,
}: PlacementColumnsOptions): ColumnDef<Placement>[] {
  return [
    {
      accessorKey: "zone",
      header: "Zone",
      cell: ({ row }) => <span className="font-mono text-sm">{row.getValue("zone")}</span>,
    },
    {
      accessorKey: "slot",
      header: "Slot",
      cell: ({ row }) => <span className="font-mono text-sm">{row.getValue("slot")}</span>,
    },
    {
      accessorKey: "label",
      header: "Label",
      cell: ({ row }) => (
        <div className="max-w-[240px] truncate font-medium">{row.getValue("label")}</div>
      ),
    },
    {
      accessorKey: "active",
      header: "Status",
      cell: ({ row }) => {
        const active = row.getValue("active") as boolean;
        return (
          <Badge variant={active ? "default" : "destructive"}>
            {active ? "Active" : "Inactive"}
          </Badge>
        );
      },
    },
    {
      accessorKey: "created_date",
      header: "Created",
      cell: ({ row }) => {
        const date = row.getValue("created_date") as string;
        return <span className="text-muted-foreground">{new Date(date).toLocaleDateString()}</span>;
      },
    },
    createActionsColumn<Placement>({ onEdit, onDelete }),
  ];
}
